import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Whether a click ended a drag that selected text: the person selected, not opened. */
export function endsTextSelection(): boolean {
  const selection = window.getSelection();
  return !!selection && !selection.isCollapsed && selection.toString().trim() !== "";
}

/**
 * Format a timestamp as a German date string (dd.mm.yyyy)
 */
export function formatDate(timestamp: string): string {
  return new Date(timestamp).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/**
 * Format a timestamp as a German date+time string (dd.mm.yyyy, hh:mm)
 */
export function formatDateTime(timestamp: string): string {
  return new Date(timestamp).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Format a number in German locale with optional fraction digits. */
export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return value.toLocaleString("de-DE", options);
}

/**
 * Format an area in m² or ha depending on size
 */
export function formatArea(areaSqm: number): string {
  if (areaSqm >= 10000) {
    return `${(areaSqm / 10000).toLocaleString("de-DE", { maximumFractionDigits: 2 })} ha`;
  }
  return `${areaSqm.toLocaleString("de-DE")} m²`;
}

/** Format a byte count as a short human-readable string ("1.2 KB" / "45.6 MB"). */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
